import { render, staticRenderFns } from "./cpsqd.vue?vue&type=template&id=4fdc6252&scoped=true"
import script from "./cpsqd.vue?vue&type=script&lang=js"
export * from "./cpsqd.vue?vue&type=script&lang=js"
import style0 from "./cpsqd.vue?vue&type=style&index=0&id=4fdc6252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc6252",
  null
  
)

export default component.exports